import { Action } from 'adaptivecards';
import { START_BOT_CONVERSATION } from '../utils/adaptiveCardActionTypes';

export default class StartBotConversation extends Action {
    public botId: string;
    public botName: string;
    public initialMessage: string;

    constructor() {
        super();
        this.botId = '';
        this.initialMessage = '';
        this.botName = '';
    }

    parse(json: any) {
        super.parse(json);
        this.isPrimary = json.isPrimary;
        this.botId = json.botId;
        this.botName = json.botName;
        this.initialMessage = json.initialMessage;
    }

    getJsonTypeName(): string {
        return START_BOT_CONVERSATION;
    }
}
